<template>
    <div :class="containerClass">
        <label :for="id" class="fw-bold" :style="labelStyle">
            {{ label }}
            <span v-if="required" class="required-fields">*</span>
        </label>
        <div>
            <label v-for="option in options" :key="option.value" class="me-3">
                <input
                    type="radio"
                    :id="id+'_'+option.value"
                    :name="name"
                    :value="option.value"
                    :checked="option.value === modelValue"
                    :disabled="disabled"
                    v-model="selectedRadioValue"
                />
                {{ option.text }}
            </label>

        </div>
        <p v-if="required && errorStatus && modelValue.length === 0" class="text-danger mt-1" :style="errorMsgStyle">
            {{ errorMessage }}
        </p>
    </div>
</template>
  
<script>
export default {
    name: "BaseRadioButton",
    props: {
        label: {
            type: String,
            default: "Select an option",
        },
        modelValue: {
            type: [String, Number],
            default: "",
        },
        id: {
            type: String,
            default: "",
        },
        name: {
            type: String,
            default: "",
        },
        options: {
            type: Array,
            default: () => [],
        },
        required: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        errorMessage: {
            type: String,
            default: "This field is required",
        },
        labelStyle: {
            type: Object,
            default: () => ({
                fontSize: '14px',
            }),
        },
        errorMsgStyle: {
            type: Object,
            default: () => ({
                fontSize: '12px',
            }),
        },
    },
    computed: {
        containerClass() {
            return "form-group col-md-3";
        },
        selectedRadioValue: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            },
        },
    },
    methods: {
        updateValue(event) {
            this.$emit('update:modelValue', event.target.value);
        }
    }
};
</script>
  
<style scoped>
.required-fields {
    color: red;
}
</style>
  